export default __webpack_public_path__ + "static/media/smoothing2.581cab5c.jpg";